import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.00001C10.22 3.00001 8.47991 3.52785 6.99987 4.51678C5.51983 5.50571 4.36627 6.91132 3.68508 8.55585C3.0039 10.2004 2.82567 12.01 3.17293 13.7558C3.5202 15.5016 4.37737 17.1053 5.63604 18.364C6.89471 19.6226 8.49836 20.4798 10.2442 20.8271C11.99 21.1743 13.7996 20.9961 15.4442 20.3149C17.0887 19.6337 18.4943 18.4802 19.4832 17.0001C20.4722 15.5201 21 13.78 21 12C21 9.61306 20.0518 7.32387 18.364 5.63604C16.6761 3.94822 14.3869 3.00001 12 3.00001ZM1 12C1 9.82441 1.64514 7.69767 2.85383 5.88873C4.06253 4.07979 5.78049 2.66989 7.79048 1.83733C9.80047 1.00477 12.0122 0.786929 14.146 1.21137C16.2798 1.6358 18.2398 2.68345 19.7782 4.22183C21.3166 5.76021 22.3642 7.72022 22.7886 9.85401C23.2131 11.9878 22.9952 14.1995 22.1627 16.2095C21.3301 18.2195 19.9202 19.9375 18.1113 21.1462C16.3023 22.3549 14.1756 23 12 23C9.08262 23 6.28473 21.8411 4.22183 19.7782C2.15893 17.7153 1 14.9174 1 12Z"
        fill="#0E1317"
      />
      <path
        d="M7.12002 16.71C7.02629 16.617 6.95189 16.5064 6.90113 16.3846C6.85036 16.2627 6.82422 16.132 6.82422 16C6.82422 15.868 6.85036 15.7373 6.90113 15.6154C6.95189 15.4936 7.02629 15.383 7.12002 15.29L15.61 6.81001C15.8036 6.66691 16.0423 6.59845 16.2824 6.61721C16.5224 6.63597 16.7476 6.74069 16.9166 6.91213C17.0856 7.08357 17.1871 7.31024 17.2024 7.55049C17.2177 7.79075 17.1459 8.02848 17 8.22001L8.54002 16.71C8.44705 16.8037 8.33645 16.8781 8.21459 16.9289C8.09273 16.9797 7.96203 17.0058 7.83002 17.0058C7.69801 17.0058 7.5673 16.9797 7.44544 16.9289C7.32358 16.8781 7.21298 16.8037 7.12002 16.71Z"
        fill="#0E1317"
      />
      <path
        d="M6.71023 6.71001C6.89759 6.52376 7.15104 6.41922 7.41523 6.41922C7.67941 6.41922 7.93286 6.52376 8.12023 6.71001L16.6102 15.19C16.7985 15.3783 16.9043 15.6337 16.9043 15.9C16.9043 16.1663 16.7985 16.4217 16.6102 16.61C16.4219 16.7983 16.1665 16.9041 15.9002 16.9041C15.6339 16.9041 15.3785 16.7983 15.1902 16.61L6.71023 8.12001C6.52398 7.93265 6.41943 7.6792 6.41943 7.41501C6.41943 7.15083 6.52398 6.89738 6.71023 6.71001Z"
        fill="#0E1317"
      />
    </Svg>
  );
};

export default Icon;
